import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugPhenytoin} from "./TextDrugPhenytoin"


export default function Phenytoin() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
 
    <ButtonsText onClick={handleOpen} name='Phenytoin' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Phenytoin - PGx Recommendation"
        content={ <TextDrugPhenytoin />}

        />

</>
)}